const MotorTipoVehiculoConstant = [
    { TipoVehiculoCoreUid: 1, TipoVehiculoMotorUid: 20006 },
    { TipoVehiculoCoreUid: 2, TipoVehiculoMotorUid: 20007 }
];

export default MotorTipoVehiculoConstant;